import { useState } from 'react';
import { handleTrack } from '../../../../../utils/tracker';
import { Button, ButtonVariants } from '../../../../Atoms/Button';
import { RightArrow } from '../../../../Icons/rightArrow/RightArrow';
import { getFileItrLink } from '../../../../cms/layout/constants';
import { PRODUCT_GUIDE_STEPS } from '../../data/product-guide.data';
import { DropDownSection } from './MobileDropdownUi';

interface ILeftTabSection {
  activeTab: string;
  handleOnTabChange: (tabId: string) => void;
}

export const LeftTabSection = ({
  activeTab,
  handleOnTabChange,
}: ILeftTabSection) => {
  const [isShowOption, setIsShowOption] = useState(false);

  const toggleOption = () => {
    setIsShowOption((prevOption) => !prevOption);
  };

  const handleFileItrButtonClick = () => {
    handleTrack({ label: 'guide_file_itr' });
    const FILING_URL = getFileItrLink().filingUrl;
    window.location.href = FILING_URL;
  };

  const handleOnTabChangeMobile = (tabId: string) => {
    setIsShowOption(false);
    handleOnTabChange(tabId);
  };

  const activeStep = PRODUCT_GUIDE_STEPS.find((step) => step.id === activeTab);
  const activeStepIndex = PRODUCT_GUIDE_STEPS.findIndex(
    (step) => step.id === activeTab
  );

  let count = 0;
  return (
    <div>
      <div
        className={`bg-black opacity-30 h-full w-full fixed top-0 bottom-0 left-0 right-0 z-10 ${
          isShowOption ? '' : 'hidden'
        }`}
      ></div>

      <div className="px-8 py-3 bg-grey-100 sticky top-0 sm:px-6 sm:py-4 sm:bg-white sm:border sm:relative sm:z-20">
        <h5 className="text-s-20 font-medium mb-2 sm:mb-0 sm:text-s-14 sm:font-semibold sm:flex sm:justify-between sm:items-center">
          <div>Step-by-step guide</div>
          <Button
            onClick={handleFileItrButtonClick}
            variant={ButtonVariants.bluefilled}
            className="rounded-sm sm:flex justify-center gap-2 hidden"
          >
            File ITR now
            <RightArrow color="#FFFFFF" width={20} height={20} />
          </Button>
        </h5>
        <div className="text-s-14 font-normal sm:hidden">
          On how to file ITR on ClearTax
        </div>
      </div>

      <div
        className={`hidden sm:block ${isShowOption ? 'sm:hidden' : ''}`}
        onClick={toggleOption}
      >
        <div
          className={`py-4 px-6 cursor-pointer font-semibold flex gap-2 text-s-12 justify-between text-[#0E4EA2] border-b border-[#E0EDFE] sm:h-14`}
        >
          <DropDownSection
            item={activeStep}
            activeTab={activeTab}
            step={activeStepIndex + 1}
          />
        </div>
      </div>

      <div
        className={`border border-[#E0EDFE] sm:rounded-b-2xl sm:shadow-2xl ${
          isShowOption ? 'sm:block absolute bg-white z-30 w-full' : 'sm:hidden'
        }`}
      >
        <div className="h-[calc(100vh-138px)] overflow-y-auto divide-y-sm divide-[#E0EDFE] sm:h-auto">
          {PRODUCT_GUIDE_STEPS?.map((item) => {
            !item.icon && count++;

            return (
              <div
                key={item.id}
                className={`cursor-pointer px-8 py-4 h-16 text-base font-semibold flex items-center gap-2 sm:text-s-12 sm:justify-between sm:py-4 sm:px-6 sm:h-14 ${
                  activeTab === item.id
                    ? 'text-[#0E4EA2] bg-[#EEF5FF]'
                    : 'text-grey-700'
                }`}
                onClick={() => handleOnTabChangeMobile(item.id)}
                data-testid="step-tabs"
              >
                <DropDownSection
                  item={item}
                  activeTab={activeTab}
                  step={count}
                  showArrow={false}
                />
              </div>
            );
          })}
        </div>

        <div className="bg-white px-8 py-3 sticky bottom-0 sm:rounded-b-2xl sm:relative">
          <Button
            onClick={handleFileItrButtonClick}
            variant={ButtonVariants.bluefilled}
            className="w-full rounded-sm flex justify-center gap-2"
          >
            File ITR now
            <RightArrow color="#FFFFFF" width={20} height={20} />
          </Button>
        </div>
      </div>
    </div>
  );
};
